import { useContext } from 'react';
import { EventsContext } from 'src/modules/alarm-processing/contexts/events/provider';
import { EventsContextProps } from 'src/modules/alarm-processing/contexts/events/types';

export function useEvents(): EventsContextProps {
    return useContext(EventsContext);
}
